import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { ActionType } from 'typesafe-actions';
import { State, Token, Introspect } from 'store/oauth/types';
import { RequestStatusTypes } from 'consts';
import ActionTypes from 'store/oauth/actionTypes';
import * as actions from 'store/oauth/actions';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';

export const initialState: State = {
  // Data
  token: {} as Token,
  gettingToken: false,
  introspect: {} as Introspect,
  // Requests statuses
  getTokenRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getIntrospectRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  forbiddenAccess: '',
};

const reducer = (
  state: State = initialState,
  action: ActionType<typeof actions>
): State => {
  switch (action.type) {
    // Reset reducer
    case ActionTypes.RESET_STATE:
      return initialState;

    case ActionTypes.RESET_TOKEN:
      return {
        ...state,
        token: initialState.token,
      };

    // Set reducer
    case ActionTypes.SET_TOKEN:
      return {
        ...state,
        token: action.payload,
      };

    case ActionTypes.GETTING_TOKEN:
      return {
        ...state,
        gettingToken: action.payload,
      };

    case ActionTypes.SET_INTROSPECT:
      return {
        ...state,
        introspect: action.payload,
      };

    // Requests statuses
    case ActionTypes.SET_GET_TOKEN_REQUEST_STATUS:
      return {
        ...state,
        getTokenRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_INTROSPECT_REQUEST_STATUS:
      return {
        ...state,
        getIntrospectRequestStatus: action.payload,
      };

    // Forbidden access
    case ActionTypes.FORBIDDEN_ACCESS:
      return {
        ...state,
        forbiddenAccess: action.payload,
      };

    default:
      return state;
  }
};

const persistConfig = {
  key: 'oauth',
  storage,
  stateReconciler: autoMergeLevel2,
  blacklist: ['getTokenRequestStatus', 'getIntrospectRequestStatus'],
};

export default persistReducer(persistConfig, reducer);
